// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2hGv1","content":"styles_content__3FCTk","checkbox":"styles_checkbox__1piPN","checkboxLabel":"styles_checkboxLabel__2IKpX"};